import React, { createContext, useState, useContext, useMemo } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

const ColorModeContext = createContext();

export const ColorModeProvider = ({ children }) => {
    // Estado do tema (pode começar como 'light' ou 'dark')
    const [mode, setMode] = useState('light');

    // Função para alternar entre claro e escuro
    const toggleColorMode = () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
    };

    // Memoriza o tema do MUI para performance, mudando só quando o 'mode' mudar
    const theme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode,
                    // Você pode customizar cores aqui se quiser
                },
            }),
        [mode]
    );

    return (
        <ColorModeContext.Provider value={{ mode, toggleColorMode }}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </ColorModeContext.Provider>
    );
};

// Hook personalizado para usar o tema nos seus componentes (ex: na página Appearance)
export const useColorMode = () => useContext(ColorModeContext);